/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  BulkConfigurationTab.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sivateja.P(H27743)
 *
 * @Date                : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sandeepraja (E807238)
 * On            : Oct 4, 2019
 * Description   : Bulk configuration tab in product configurations tab
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.
 *
 * By            : H224423
 * On            : 24 Oct 2019
 * Description   : ASDS-1256. Used reused component from configure product file. Integrated read excel service.
 *
 * By            : H224423
 * On            : 25 Nov 2019
 * Description   : Added bulk upload validation error message.
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Jan 02, 2020
 * Description   : Updated FileDrop UT cases
 *
 * By            : H224423
 * On            : Jan 03, 2020
 * Description   : Removed FileDropExample Component, integrated forge UI FileDrop Component directly.
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Aspire UI enhancements of Phase-2
 *
 ******************************************************************************/

import * as React from 'react';
import { Card, Grid, Stepper, FileDrop, Icon } from '@scuf/common';
import { connect } from 'react-redux';
import '@scuf/common/honeywell/theme.css';
import './bulkConfig.css';
import {DisplaySCMCard} from '../ConfigureProduct/displaySCMCart';
import { ConfigSummary } from '../ConfigureProduct/configSummary';
import TotalPriceCard from '../ConfigureAPU/TotalPriceCard';

import ConfigureProductActions from '../redux/actions/configure-product-actions';

export function BulkConfigurationStepper(props) {
  const stepper = (
    <Stepper ordered={true} className="stepperClass ca-stepper">
      <Stepper.Item
        title="Upload Configuration Template"
        icon="file-upload"
        iconRoot="building"
        size="xlarge"
        active={props.activeTab === 4}
        completed={props.activeTab > 4}
      />
      <Stepper.Item
        title=" Confirm Configuration"
        iconRoot="common"
        icon="document-confirm"
        active={props.activeTab === 5}
        disabled={props.activeTab !== 5}
      />
    </Stepper>
  );
  return stepper;
}

export function UploadTemplate(props) {
  const content = (
    <div>
      <FileDrop
                    acceptedTypes={['.xlsx']}
                    placeholder="Drop a file to upload"
                    multiple={false}
                    onAccepted={(files) => {props.validateUploadedBulkConfigFile(files, true); }}
                    onRejected={(files) => {props.validateUploadedBulkConfigFile(files, false); }}
                    onReset={() => {props.validateUploadedBulkConfigFile('', false); }}
                    resetButtonText={'Change File'}
                    className="file-drop-div"
                    error = {props.bulkError}
      />
      <Grid>
        <Grid.Row>
          <Grid.Column width={12} className="bc-config-temp-link">
            <span className="bc-config-link">Don’t Have Config. Template?</span>
            <a href={props.configTemplateLink} className="bc-download-link">Download Now</a>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
  return content;
}

function UploadedFileCard(props) {
  const content = (
    <Card>
      <Card.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column width={11}>

                  <p className="cp-serial-title-text">UPLOADED FILE NAME </p>
               </Grid.Column>
               <Grid.Column width={1}>
               <div className="cp-conf-edit"><Icon root="common" name="edit" size="small"
                                                            onClick={props.gotoBulkFileUploadTab} /></div>

            </Grid.Column>
                <Grid.Column width={12}>
                  <p >{props.uploadedConfigFile.name}</p>
                </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
  return content;
}

export function ConfirmOrder(props) {
  const content = (

    <Grid className="fullwidthGrid" data-testid="t-ConfirmOrder-content">
      <Grid.Row>
        <Grid.Column width={12}>
          {/********************First card block starts here*******************/}

          <UploadedFileCard {...props} />
        </Grid.Column>
      </Grid.Row>

      {/********************First card block ends here*******************/}
      {/* <h3 className="cp-conf-sub-heading">Confirm Serial Numbers, Features upload in Template.</h3>
      <Grid.Row>
        <Grid.Column width={12}>
        {props.bulkValidationError ? <div className="cp-bulk-error-msg">{props.bulkValidationError}</div> : ''}
        </Grid.Column>
      </Grid.Row> */}
      <Grid.Row>
        <Grid.Column width={12}>
        <DisplaySCMCard gotoSCMSerialNumbersTab={props.gotoStep1SCMSerialNumbersTab} SCMSerialNumbers={props.productSerialNumbers} />

        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={12}>
        <ConfigSummary gotoConfigureFeaturesTab={props.gotoStep1ConfigureFeaturesTab} productFeatures={props.productFeatures} />
        <TotalPriceCard totalPrice={props.totalPrice} />

        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
  return content;
}

interface IBulkConfigContent {
    productFeatureMasterData: [];
    productFeatures: [];
    productSerialNumbers: [];
    totalPrice: number;
    activeTab: number;
    redirectTo: string;
    isFeatureMasterDataFetching: boolean;
    uploadedConfigFile: File;
    bulkValidationError: string;
    validateUploadedBulkConfigFile: Function;
    gotoBulkFileUploadTab: Function;
    gotoStep1SCMSerialNumbersTab: Function;
    gotoStep1ConfigureFeaturesTab: Function;
    gotoSCMSerialNumbersTab: Function;
    gotoConfigureFeaturesTab: Function;
}

function BulkConfigContent(props: IBulkConfigContent) {
  let cardContent;
  if (props.activeTab === 4) {
    cardContent = (
      <UploadTemplate {...props} />
    );
  } else {
    cardContent = <ConfirmOrder {...props} />;
  }
  return cardContent;
}

const mapDispatchToProps = {
  gotoBulkFileUploadTab: ConfigureProductActions.gotoBulkFileUploadTab,
  gotoStep1SCMSerialNumbersTab: ConfigureProductActions.gotoStep1SCMSerialNumbersTab,
  gotoStep1ConfigureFeaturesTab: ConfigureProductActions.gotoStep1ConfigureFeaturesTab,
  validateUploadedBulkConfigFile: ConfigureProductActions.validateUploadedBulkConfigFile,
    gotoSCMSerialNumbersTab: ConfigureProductActions.gotoSCMSerialNumbersTab,
    gotoConfigureFeaturesTab: ConfigureProductActions.gotoConfigureFeaturesTab,
};

function mapStateToProps(state) {
  return {
    productFeatureMasterData: state.configProductData.payload.featuresMasterData,
    productFeatures: state.configProductData.payload.productFeatures,
    productSerialNumbers: state.configProductData.payload.serialNumbers,
    totalPrice: state.configProductData.payload.totalPrice,
    activeTab: state.configProductData.payload.activeTab,
    redirectTo: state.configProductData.payload.redirectTo,
    isFeatureMasterDataFetching:
    state.configProductData.payload.isFeatureMasterDataFetching,
    uploadedConfigFile: state.configProductData.payload.uploadedConfigFile,
    bulkValidationError: state.configProductData.payload.bulkValidationError,
    bulkError:state.configProductData.payload.bulkError,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkConfigContent);
